import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id C3D19BD6-D474-4F86-94AA-1A4B04FE8E3A
 * name silverware-fork-knife
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/silverware-fork-knife.svg
 * tags
 * - Food / Drink 
 */
export const SilverwareForkKnifeIcon = createSvgIcon(<><path d="M11,9H9V2H7V9H5V2H3V9C3,11.12 4.66,12.84 6.75,12.97V22H9.25V12.97C11.34,12.84 13,11.12 13,9V2H11V9M16,6V14H18.5V22H21V2C18.24,2 16,4.24 16,6Z" /></>, 'SilverwareForkKnifeIcon');
export default SilverwareForkKnifeIcon